(function ($) {


    $('.followme-newsletter-box').submit(function (e) {
        e.preventDefault(); // avoid to execute the actual submit of the form.
        var form = $(this);

        var process = true;

        var email = $('#followme-newsletter-box-email');
        var checkbox = $('#followme-newsletter-box-checkbox');
        var messageBox = $('#followme-newsletter-box-message');
        var messageBoxText = "";

        messageBox.html("");

        checkbox.parent().removeClass('has-error');
        email.removeClass('has-error');
        messageBox.removeClass('has-error');

        if (checkbox.prop('checked') === false && email.val() === "") {
            checkbox.parent().addClass('has-error');
            email.addClass('has-error');
            messageBoxText = newsletterTranslate.email_checkbox_error;
            process = false;
        } else if (checkbox.prop('checked') === false && email.val() !== "") {
            checkbox.parent().addClass('has-error');
            messageBoxText = newsletterTranslate.checkbox_error;
            process = false;
        } else if (email.val() === "" && checkbox.prop('checked') !== false) {
            email.addClass('has-error');
            messageBoxText = newsletterTranslate.email_error;
            process = false;
        }


        if (process) {
            $.ajax({
                type: "POST",
                url: form.attr('action'),
                data: form.serialize(),
                beforeSend: function () {
                },
                success: function (data) {
                    messageBox.html(newsletterTranslate.success_text);
                    email.val("");
                    checkbox.prop("checked", false);
                }
            });
        } else {
            messageBox.addClass('has-error');
            messageBox.html(messageBoxText);
        }

    });

})(jQuery);